'use memo';

import { useState } from 'react';
import Combobox from '@/components/Combobox';
import { useDebouncedCallback } from '@/hooks/useDebouncedCallback';
import type { ValueToLabelCache } from '@/hooks/useValueToLabelCache';
import { useBusinessPartners } from './-query';
import type { BusinessPartnerOption } from './-query/type';
interface BusinessPartnerComboboxProps {
  value: string | null;
  onValueChange: (value: string | null, option?: BusinessPartnerOption) => void;
  valueToLabelCache: ValueToLabelCache;
}
export const BusinessPartnerCombobox = ({
  value,
  onValueChange,
  valueToLabelCache
}: BusinessPartnerComboboxProps) => {
  const [searchText, setSearchText] = useState('');
  const debouncedSetSearchText = useDebouncedCallback((text: string) => setSearchText(text), []);
  const {
    data: options,
    isLoading
  } = useBusinessPartners(searchText);
  const handleValueChange = (newValue: string | null) => {
    const option = options?.find(o => o.value === newValue);
    onValueChange(newValue, option);
  };
  return <Combobox<BusinessPartnerOption> type="single" value={value} options={options} isFetching={isLoading} onValueChange={handleValueChange} onSearchChange={debouncedSetSearchText} valueToLabelCache={valueToLabelCache} />;
};